"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticateProcessor = void 0;
exports.resetAuthAttemptCounter = resetAuthAttemptCounter;
var biometric_auth_1 = require("../../../app/api/calls/user/authentication/biometric_auth");
var facetec_reference_sync_1 = require("../../../app/api/calls/user/facetec_reference_sync");
var Config_1 = require("../../../app/Config");
var DeveloperStatusMessages_1 = require("../utilities/DeveloperStatusMessages");
var FaceTecSDK_1 = require("./../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
// Maximum number of authentication attempts before showing "contact staff" message
var MAX_AUTH_ATTEMPTS = 3;
// Static counter to track authentication attempts across sessions
var authAttemptCount = 0;
/**
 * Resets the authentication attempt counter.
 * Call this when user logs out or successfully completes authentication.
 */
function resetAuthAttemptCounter() {
    authAttemptCount = 0;
    console.log("🔄 Authentication attempt counter reset");
}
var AuthenticateProcessor = /** @class */ (function () {
    function AuthenticateProcessor(sessionToken, sampleAppControllerReference) {
        var _this = this;
        this.latestNetworkRequest = new XMLHttpRequest();
        //
        // Part 10:  This function gets called after the FaceTec SDK is completely done.  There are no parameters because you have already been passed all data in the processSessionWhileFaceTecSDKWaits function and have already handled all of your own results.
        //
        this.onFaceTecSDKCompletelyDone = function () {
            //
            // DEVELOPER NOTE:  onFaceTecSDKCompletelyDone() is called after you signal the FaceTec SDK with success() or cancel().
            // Calling a custom function on the Sample App Controller is done for demonstration purposes to show you that here is where you get control back from the FaceTec SDK.
            //
            _this.success = _this.latestSessionResult.isCompletelyDone;
            // Log success message
            if (_this.success) {
                DeveloperStatusMessages_1.DeveloperStatusMessages.logMessage("Authenticated");
            }
            _this.sampleAppControllerReference.onComplete(_this.latestSessionResult, null, _this.latestNetworkRequest.status);
        };
        // Helper function to ensure the session is only cancelled once
        this.cancelDueToNetworkError = function (networkErrorMessage, faceScanResultCallback) {
            if (_this.cancelledDueToNetworkError === false) {
                console.log(networkErrorMessage);
                _this.cancelledDueToNetworkError = true;
                faceScanResultCallback.cancel();
            }
        };
        //
        // DEVELOPER NOTE:  This public convenience method is for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In your code, you may not even want or need to do this.
        //
        this.isSuccess = function () {
            return _this.success;
        };
        //
        // DEVELOPER NOTE:  These properties are for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In the code in your own App, you can pass around signals, flags, intermediates, and results however you would like.
        //
        this.success = false;
        this.sampleAppControllerReference = sampleAppControllerReference;
        this.latestSessionResult = null;
        this.cancelledDueToNetworkError = false;
        this.hasRetriedWithFirebaseRef = false;
        //
        // Part 1:  Starting the FaceTec Session
        //
        // Required parameters:
        // - FaceTecFaceScanProcessor:  A class that implements FaceTecFaceScanProcessor, which handles the FaceScan when the User completes a Session.  In this example, "this" implements the class.
        // - sessionToken:  A valid Session Token you just created by calling your API to get a Session Token from the Server SDK.
        //
        new FaceTecSDK_1.FaceTecSDK.FaceTecSession(this, sessionToken);
    }
    //
    // Part 2:  Handling the Result of a FaceScan
    //
    AuthenticateProcessor.prototype.processSessionResultWhileFaceTecSDKWaits = function (sessionResult, faceScanResultCallback) {
        var _this = this;
        this.latestSessionResult = sessionResult;
        //
        // Part 3:  Handles early exit scenarios where there is no FaceScan to handle -- i.e. User Cancellation, Timeouts, etc.
        //
        if (sessionResult.status !==
            FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
            console.log("Session was not completed successfully, cancelling.  Session Status: " +
                FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus[sessionResult.status]);
            this.latestNetworkRequest.abort();
            faceScanResultCallback.cancel();
            return;
        }
        // IMPORTANT:  FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully DOES NOT mean the Authenticate was Successful.
        // It simply means the User completed the Session and a 3D FaceScan was created.  You still need to perform the Authentication on your Servers.
        //
        // Part 4:  Get essential data off the FaceTecSessionResult
        //
        //Get
        var parameters = {
            faceScan: sessionResult.faceScan,
            auditTrailImage: sessionResult.auditTrail[0],
            lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0],
            // sessionId: sessionResult.sessionId,
            externalDatabaseRefID: this.sampleAppControllerReference.getLatestEnrollmentIdentifier(),
        };
        //
        // Part 5:  Make the Networking Call to Your Servers.  Below is just example code, you are free to customize based on how your own API works.
        //
        //TODO - Add .content
        this.latestNetworkRequest = new XMLHttpRequest();
        this.latestNetworkRequest.open("POST", Config_1.Config.BaseURL + "/match-3d-3d");
        this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
        this.latestNetworkRequest.setRequestHeader("X-Device-Key", Config_1.Config.DeviceKeyIdentifier);
        this.latestNetworkRequest.setRequestHeader("X-User-Agent", FaceTecSDK_1.FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId));
        this.latestNetworkRequest.onreadystatechange = function () {
            //
            // Part 6:  In our Sample, we evaluate a boolean response and treat true as was successfully processed and should proceed to next step,
            // and handle all other responses by cancelling out.
            // You may have different paradigms in your own API and are free to customize based on these.
            //
            var _a;
            // TODO - Add .content
            if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                try {
                    console.log("🔍 FaceTec API Response Status:", _this.latestNetworkRequest.status);
                    console.log("🔍 FaceTec API Response Text:", _this.latestNetworkRequest.responseText);
                    var parsedResponse = JSON.parse((_a = _this.latestNetworkRequest) === null || _a === void 0 ? void 0 : _a.responseText);
                    // Check if response has error format (success: false)
                    if (parsedResponse.success === false) {
                        console.error("❌ Backend API Error:", parsedResponse.message);
                        _this.cancelDueToNetworkError("Backend API Error: ".concat(parsedResponse.message), faceScanResultCallback);
                        return;
                    }
                    var responseJSON = parsedResponse.content;
                    if (!responseJSON) {
                        console.error("❌ Response missing 'content' property:", parsedResponse);
                        _this.cancelDueToNetworkError("Invalid API response format - missing 'content' property", faceScanResultCallback);
                        return;
                    }
                    console.log("🔍 Parsed responseJSON.content:", responseJSON);
                    var scanResultBlob = responseJSON.scanResultBlob;
                    // In v9.2.0+, we key off a new property called wasProcessed to determine if we successfully processed the Session result on the Server.
                    // Device SDK UI flow is now driven by the proceedToNextStep function, which should receive the scanResultBlob from the Server SDK response.
                    if (responseJSON.wasProcessed) {
                        // Check if authentication actually succeeded (liveness passed and face matched)
                        var authenticationSucceeded = responseJSON.success === true ||
                            (responseJSON.faceScanLivenessCheckSucceeded === true &&
                                responseJSON.matchLevel > 0);
                        if (authenticationSucceeded) {
                            // Reset attempt counter on success
                            authAttemptCount = 0;
                            (0, biometric_auth_1.biometric_auth)(responseJSON);
                            // Demonstrates dynamically setting the Success Screen Message.
                            FaceTecSDK_1.FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage("Authenticated");
                            // In v9.2.0+, simply pass in scanResultBlob to the proceedToNextStep function to advance the User flow.
                            // scanResultBlob is a proprietary, encrypted blob that controls the logic for what happens next for the User.
                            faceScanResultCallback.proceedToNextStep(scanResultBlob);
                        }
                        else {
                            // Authentication processed but FAILED (liveness failed or no match)
                            authAttemptCount++;
                            console.log("\u274C Authentication failed. Attempt ".concat(authAttemptCount, " of ").concat(MAX_AUTH_ATTEMPTS));
                            console.log("🔍 Failure details:", {
                                success: responseJSON.success,
                                livenessCheckSucceeded: responseJSON.faceScanLivenessCheckSucceeded,
                                matchLevel: responseJSON.matchLevel,
                            });
                            // Check if this is an "enrollment does not exist" error
                            var errorMessage = responseJSON.errorMessage || "";
                            var isEnrollmentNotFound = errorMessage
                                .toLowerCase()
                                .includes("enrollment does not exist");
                            if (isEnrollmentNotFound && !_this.hasRetriedWithFirebaseRef) {
                                console.log("🔍 Enrollment not found - checking Firebase for correct reference...");
                                // Get the reference we used for this attempt
                                var usedReference = _this.sampleAppControllerReference.getLatestEnrollmentIdentifier();
                                // Handle the enrollment not found scenario
                                (0, facetec_reference_sync_1.handleEnrollmentNotFound)(usedReference)
                                    .then(function (result) {
                                    var _a, _b;
                                    if (result.action === "retry") {
                                        console.log("🔄 Firebase has different reference, will retry with:", result.newReference);
                                        _this.hasRetriedWithFirebaseRef = true;
                                        // Update the enrollment identifier in the controller
                                        _this.sampleAppControllerReference.setLatestEnrollmentIdentifier(result.newReference);
                                        // Signal user to retry (cancel this session, they need to try again)
                                        DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Reference updated from Firebase. Please try authentication again.");
                                        faceScanResultCallback.cancel();
                                    }
                                    else {
                                        console.log("🗑️ References cleared, re-enrollment required");
                                        DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Enrolment not found. Please complete Facial Recognition enrolment first.");
                                        // Signal that enrollment is needed
                                        (_b = (_a = _this.sampleAppControllerReference).onEnrollmentRequired) === null || _b === void 0 ? void 0 : _b.call(_a);
                                        faceScanResultCallback.cancel();
                                    }
                                })
                                    .catch(function (error) {
                                    console.error("Error handling enrollment not found:", error);
                                    _this.cancelDueToNetworkError("Error checking Firebase reference.", faceScanResultCallback);
                                });
                            }
                            else if (authAttemptCount >= MAX_AUTH_ATTEMPTS) {
                                // User has exhausted all attempts - show contact staff message
                                console.log("🚫 Max authentication attempts reached. User should contact staff.");
                                DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Authentication failed after multiple attempts. Please contact staff for assistance.");
                                // Reset counter for next time
                                authAttemptCount = 0;
                                faceScanResultCallback.cancel();
                            }
                            else {
                                // Allow FaceTec SDK to handle retry screen
                                // The scanResultBlob contains info about what screen to show next
                                console.log("\uD83D\uDD04 Allowing retry. Attempts remaining: ".concat(MAX_AUTH_ATTEMPTS - authAttemptCount));
                                faceScanResultCallback.proceedToNextStep(scanResultBlob);
                            }
                        }
                    }
                    else {
                        console.log("Failed: wasProcessed is false", responseJSON);
                        // CASE:  UNEXPECTED response from API - scan was not processed
                        _this.cancelDueToNetworkError("Scan could not be processed. Please try again.", faceScanResultCallback);
                    }
                }
                catch (error) {
                    // CASE:  Parsing the response into JSON failed --> You define your own API contracts with yourself and may choose to do something different here based on the error.  Solid server-side code should ensure you don't get to this case.
                    console.error("❌ FaceTec API Response Parsing Error:", error);
                    console.error("❌ Response Status:", _this.latestNetworkRequest.status);
                    console.error("❌ Response Text:", _this.latestNetworkRequest.responseText);
                    _this.cancelDueToNetworkError("Exception while handling API response, cancelling out.", faceScanResultCallback);
                }
            }
        };
        this.latestNetworkRequest.onerror = function () {
            // CASE:  Network Request itself is erroring --> You define your own API contracts with yourself and may choose to do something different here based on the error.
            _this.cancelDueToNetworkError("XHR error, cancelling.", faceScanResultCallback);
        };
        //
        // Part 7:  Demonstrates updating the Progress Bar based on the progress event.
        //
        this.latestNetworkRequest.upload.onprogress = function (event) {
            var progress = event.loaded / event.total;
            faceScanResultCallback.uploadProgress(progress);
        };
        //
        // Part 8:  Actually send the request.
        //
        var jsonStringToUpload = JSON.stringify(parameters);
        this.latestNetworkRequest.send(jsonStringToUpload);
        //
        // Part 9:  For better UX, update the User if the upload is taking a while.  You are free to customize and enhance this behavior to your liking.
        //
        window.setTimeout(function () {
            if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                return;
            }
            faceScanResultCallback.uploadMessageOverride("Still Uploading...");
        }, 6000);
    };
    return AuthenticateProcessor;
}());
exports.AuthenticateProcessor = AuthenticateProcessor;
